/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

/**
 * Override field
 */
export enum SecurityValueOverrideField {
    VALUE_PER_UNIT = 'VALUE_PER_UNIT',
    VALUE_TOTAL_ISSUED = 'VALUE_TOTAL_ISSUED',
}
